import Vue from 'vue';
import Vuex, { ActionContext } from 'vuex';

Vue.use(Vuex);

export interface RootState {
    safeMode: boolean;
}

type RootContext = ActionContext<RootState, RootState>;

const rootStore = new Vuex.Store<RootState>({
    state: {
        safeMode: false
    },
    getters: {
        getSafeMode: state => {
            return state.safeMode;
        }
    },
    mutations: {
        activateSafeMode: function(state: RootState){
            state.safeMode = true;
        },
        deactivateSafeMode: function(state: RootState){
            state.safeMode = false;
        }
    },
    modules: {}
});

export default rootStore;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/store/index.ts